import { render } from "./MemberBetLimitList.vue?vue&type=template&id=0d0f59cb&scoped=true"
import script from "./MemberBetLimitList.vue?vue&type=script&lang=js"
export * from "./MemberBetLimitList.vue?vue&type=script&lang=js"

import "./MemberBetLimitList.vue?vue&type=style&index=0&id=0d0f59cb&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d0f59cb"]])

export default __exports__